import { SPRINT_TYPE } from '@atlassian/jira-platform-field-config/src/index.tsx';
import type { FormatRule, EvaluateHandler } from '../../../evaluate-format-rule/types.tsx';
import type { TransformedSprintField } from '../types.tsx';

const evaluateHandler: EvaluateHandler<TransformedSprintField> = {
	IS: (field, value) => Boolean(field.value.length && field.value[0]?.sprintId === value),
	IS_NOT: (field, value) => Boolean(field.value.length && field.value[0]?.sprintId !== value),
	IS_EMPTY: (field) => !field.value || !field.value.length,
	IS_NOT_EMPTY: (field) => Boolean(field.value.length),
};

const evaluateFormatRule: FormatRule<TransformedSprintField> = ({ field, operator, value }) => {
	const evaluateHandlerFn = evaluateHandler[operator];
	if (!evaluateHandlerFn) return false;
	return evaluateHandlerFn(field, value);
};

export const sprintEvaluateFormatRule = {
	[SPRINT_TYPE]: evaluateFormatRule,
};
